import styled, { css } from 'styled-components';
import { Modal } from '@alefeducation/ui-elements-library-core';

export const StyledHeaderContainer = styled.div`
  margin-bottom: ${({ theme: { space } }: any) => `${space[14]}px`};
`;

export const StyledLabelContainer = styled.div`
  font-weight: 300;
  margin-bottom: ${({ theme: { space } }: any) => `${space[8]}px`};
  margin-top: ${({ theme: { space } }: any) => `${space[8]}px`};
`;

export const StyledDescription = styled.div`
  font-weight: 300;
  margin-top: ${({ theme: { space } }: any) => `${space[14]}px`};
`;
export const MultiSelectContainer = styled.div`
  #select {
    & > span {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  width: auto;
`;

export const StyledFormControlContainer = styled.div<{ isDisabled?: boolean }>`
  margin-bottom: ${({ theme: { space } }: any) => `${space[10]}px`};

  ${(props) =>
    props.isDisabled &&
    css`
      * {
        color: ${props.theme.colors.primary[40]};
      }
      pointer-events: none;
      .org-multiselect-container {
        background-color: #ecedef66;
      }
    `}
`;

export const MandatorySpan = styled.span`
  color: red;
`;

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;

  > div:first-child {
    width: 54%;
  }
  > div:nth-child(2) {
    width: 40%;
  }
  > div:nth-child(3) {
    width: 10%;
    > label {
      margin-left: 4px;
    }
  }
  & input {
    border-color: #b6bbc1;
  }
`;

export const StyleCountryRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
  width: 100%;
  > div:first-child {
    width: 50%;
  }
  > div {
    width: 50%;
  }

  & div[role='combobox'] {
    width: 100%;
    position: static;
  }
`;

export const StyledModal = styled(Modal)`
  .MuiDialog-paper {
    position: static;
  }

  .fade-effect {
    display: none;
  }
`;

export const CheckBoxContainer = styled.div`
  align-self: flex-end;
  margin-bottom: 14px;
  flex: 1;
  display: flex;
  align-items: center;
`;

export const DatePickerColumn = styled.div<{ isDisabled?: boolean }>`
  flex: 1;

  ${(props) =>
    props.isDisabled &&
    css`
      color: ${props.theme.colors.primary[40]};
      button {
        background-color: #ecedef66 !important;
      }
    `}
`;
